module.exports = __webpack_public_path__ + "static/fun-time/audio/karta2//10_yellow.mp3";